export default {
    DOMAIN: 'https://www.theholyroad.org',
    IMAGE_FOLDER: '/images/',
    STORY_URL: '/artikel/'
}



// WEBPACK FOOTER //
// ./src/common/constants.js